module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "f0024-01"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0024-01.jpg"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "section_hd"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("LEGENDARY BARBECUE")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("The Evolution of the Pit")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "f0026-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0026-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Forty-two cattle were barbecued for a “Get Together” to bring farmers and townspeople together, Victoria, 1921. (Note the axles used as crossbars.)")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('span', {
    staticClass: "drop_cap"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/t.jpg"
    }
  })]), _vm._v("he pitmaster squints into the smoke as he opens the giant steel door. From your place in line, you watch him fork and flip the juicy, black beef clods and sizzling pork loins. Your heart beats faster as he reveals a dozen sausage rings hissing and spitting in the thick white cloud. Slowly, the sweet oak smoke makes its way to you, carrying with it the aroma of peppery beef, bacon-crisp pork, and juicy garlic sausage. Your mouth starts watering.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("You swallow hard. Your stomach rears back and lets out a growl. You’re in a frenzy by the time you get to the head of the line, where the hot meats are being sliced and weighed. You order twice as much as you can eat. You carry it away on a sheet of butcher paper, with an extra sheet tucked underneath for a plate.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Welcome to Texas barbecue. We love to eat it. We love to make it. And we love to argue about it. We have competing theories on the etymology and the definition of the word and on which characteristics make it uniquely Texan. We don’t agree on the kind of wood, the need for sauce, the cut of meat, or which part of the state does it best. And we all have our favorite pitmasters. But we all agree that non-Texans don’t understand it.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "f0029-01"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0029-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pitmaster Roy Perez at the old Kreuz Market.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_c('em', [_vm._v("Photo by Wyatt McSpadden")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "f0030-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0030-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "brown1"
  }, [_vm._v("Men in suits waiting for barbecued mutton cooking on an open pit, 1921.")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("Traditional barbecue definitions don’t make sense here. “Barbecue is always served with a distinctive sauce,” say some. Not in Texas, where the sauce is on the side and many connoisseurs elect to eat their smoked meats with no sauce at all. “Barbecue means slow cooking over the low heat of a wood or charcoal fire,” say others. Sorry. Some of the best smoked meat in the Lone Star State is cooked at 500°F.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("So what is Texas barbecue exactly? If we can’t quite agree on what it is, at least we can agree on where it came from. Looking at Texas barbecue history may be the easiest way to understand it.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("If you include roasting meat on an open fire in your definition of barbecue, then the earliest Texans to barbecue were the Caddo Indians, who cooked venison and other game here thousands of years ago. They were followed by the Spanish shepherds, who spit-roasted kid goat and lamb "), _c('em', [_vm._v("al pastor")]), _vm._v(" (shepherd style) on the South Texas plains, starting in the 1600s. Mexican barbacoa, meat sealed in maguey leaves and buried in a "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('em', [_vm._v("pozo")]), _vm._v(" (pit) full of hot rocks, was common in South Texas before the earliest Anglo settlers began to arrive in the 1820s. In modified forms, it can still be found today at barbacoa eateries like Vera’s Backyard Bar-B-Que in Brownsville.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The largest influx of Southerners was the group called the Old Three Hundred, 297 primarily wealthy plantation owners who, in 1824, populated Stephen F. Austin’s colony, which he had acquired through a Mexican colonization grant. Attracted by the rich soil of the river bottom lands of the Brazos Valley, these cotton planters replicated the culture of the Old South in Texas, including Southern-style barbecue. They brought their slaves with them, and African-Americans became the earliest pitmasters in Texas, just as they had been in the rest of the South.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Pits were typically three feet deep, twenty-five feet long, and three feet across. Whole sheep, goats, pigs, and steers were slaughtered on the spot, cut into pieces, and cooked over oak or hickory coals while being continuously basted. The standard cooking time was twenty-four hours. Southern-style pit barbecue can still be seen today in the community barbecues held in Austin County, not far from the area where Austin’s colony was once headquartered.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The earliest mention of Texas barbecue in print is from an 1832 handbill advertising a Shelby County revival meeting, where free barbecue was handed out to all comers. Barbecue had become an integral part of the Protestant religious rallies that began in the late 1700s in Kentucky and spread religion across the frontier. The camp meetings were usually held from Thursdays through Sundays, with free barbecue all weekend.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0031-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0031-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('a', {
    attrs: {
      "id": "pg31lev1"
    }
  }), _vm._v("Civic Barbecues")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Big public barbecues were held for all kinds of reasons in the early days of the Lone Star State. In fact, no civic celebration was complete without one.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("In 1853, the town of Stafford gave away free barbecue to the public to celebrate becoming a stop on the Buffalo Bayou, Brazos and Colorado Railway.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("In 1860, Sam Houston spoke at the Great American Barbecue, a political rally thrown by the American Party in Austin. All citizens of the state were invited to attend and eat for free.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("In 1891, the citizens of Whitney, a town with a declining population, held a barbecue to promote the benefits of citizenship. They gave away thirty-five hundred pounds of barbecue.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("In 1926, Edgar Byram Davis closed what was probably the biggest oil deal in the state up to that time. He got $12 million (half of it in cash) for his Luling oil holdings, and he held a free barbecue to celebrate. Attendance estimates run as high as thirty-five thousand.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("In 1941, at his inauguration celebration, Governor W. Lee “Pappy” O’Daniel set up pits on the grounds of the capitol building in Austin and gave away barbecue to all comers.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("In 1964, President Lyndon Johnson hosted the president-elect of Mexico at a state dinner at the LBJ Ranch in Johnson City. Catered by Walter Jetton, this dinner for two hundred fifty was reportedly America’s first official barbecue state dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("In 1991, the pitmasters at XIT Rodeo and Reunion in Dalhart cooked eleven thousand pounds of beef in open pits dug with backhoes. The meat was served to twenty thousand guests. The XIT barbecue is still held every year.")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "f0032-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0032-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Overview of the crowd at the barbecue on the state capitol grounds celebrating Governor “Pappy” O’Daniel’s inauguration in 1941. The large circles are cowboy hats, the little white circles are plates.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "f0034-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0034-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "brown1"
  }, [_vm._v("Governor W. Lee “Pappy’ O’Daniel poses with a mop while pretending to cook barbecue in an open pit on the capitol grounds during his inauguration celebration, 1941.")])]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Old-world meat smoking was brought to Central Texas by German and Czech butchers during an era of intense European migration that began in the 1830s and reached its height around 1890. The German meat markets sold fresh meats and smoked their leftovers in enclosed smokers, as they had done in the Old Country. They were probably astonished when migrant farmworkers began the tradition of eating that smoked meat on the spot. When food "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("cooked in earthen pits was judged unsanitary by early health inspectors after the reforms of the Progressive Era in the early 1900s, the indoor German smokers became the model for barbecue restaurants. Which is why many people consider the old meat markets to be quintessential Texas barbecue joints, despite the fact that German smoked meats and sausages aren’t really American barbecue.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Texas departed from the Southern “pork only” tradition, as well. After the Civil War, beef became the meat most characteristic of Texas barbecue. In the days before refrigeration, barbecuing beef meant getting enough people together to make killing a whole steer worthwhile. When that happened, it was quite a party. Although the ultimate in Southern barbecue was cooking a whole hog, cooking a whole steer was the ultimate in Texas barbecue.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Because you could feed so many people with a whole steer, Texas barbecues started out big—and then they got bigger. Texans being Texans, barbecues became competitions, and each barbecue became an effort to outdo all others. This tradition lives on in such events as the XIT Rodeo and Reunion in Dalhart, where tens of thousands of people gather each year to attend the “world’s largest free barbecue.”")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg35lev1"
    }
  }), _c('span', {
    staticClass: "brown"
  }, [_vm._v("The Barbecue Barons")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Walter Jetton of Fort Worth was the single most influential figure in Texas barbecue history. For many years, Jetton held the record for barbecue catering, having fed twelve thousand people at one of his “chuck wagon dinners.”")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("During Lyndon Johnson’s presidency, Jetton became nationally famous for his barbecues at the LBJ ranch. In 1965, Pocket Books published "), _c('em', [_vm._v("Walter Jetton’s LBJ Barbecue Cook Book")]), _vm._v(". In the book he advised: “To barbecue, you need a pit . . . This doesn’t have to be a hole in the ground, and it definitely shouldn’t be one of those backyard creations with a chimney.” A fire built in a cinder block enclosure was perfect in his view.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_c('a', {
    attrs: {
      "id": "pg35lev2"
    }
  }), _vm._v("Linguistic Lore"), _c('br'), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0035-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("Over the years, some pretty fantastic etymologies for the word "), _c('em', [_vm._v("barbecue")]), _vm._v(" have been advanced. Two cookbooks I’ve seen recount the tale of a wealthy Texas rancher who fed all of his friends whole sheep, hogs, and cattle roasted over open pits. In one cookbook, the rancher’s name is Bernard Quayle, and in the other, it is Barnaby Quinn, but both describe the branding iron of the ranch as having the initials B. Q. with a straight line underneath. Texas ranches are named for their brands, and a straight line is called a bar. Thus, the “bar B. Q.” became synonymous with fine eating—or so the story goes.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("The late Corpus Christi barbecue legend Joe Cotten used to tell journalists that the word "), _c('em', [_vm._v("barbecue")]), _vm._v(" came from the French phrase "), _c('em', [_vm._v("barbe à queue")]), _vm._v(", meaning “from the beard to the tail.” The phrase supposedly refers to the fact that the whole animal is roasted. The reporters passed along Joe’s wisdom to many readers, and this explanation is still widely circulated. The "), _c('em', [_vm._v("Oxford English Dictionary")]), _vm._v(" calls this particular etymology “absurd conjecture.”")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "f0036-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0036-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "brown1"
  }, [_vm._v("Legendary Fort Worth barbecuer Walter Jetton.")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("But Jetton actually had two different barbecue styles—one for catering and another at his eponymous restaurant in Fort Worth. For chuck wagon events, Jetton cooked meat outdoors in cinder-block pits directly over the coals for eighteen to twenty-four hours. But that wouldn’t work in a restaurant.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("County health departments regulate barbecue pits in Texas food service establishments. The regulations, and how strictly they are enforced, have varied widely from county to county since the laws first hit the books during the sanitation crusades of the Progressive Era in the early 1900s.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The brick smokers of the old German-belt meat markets, some built more than a hundred years ago, offered a design that was adopted by other barbecue restaurants once the outdoor pits were outlawed. But the mystique of African-American barbecue pitmasters continued—some restaurants proudly "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("advertised that they had black pitmasters manning the indoor barbecue pits.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("In a 1956 story in the Saturday Evening Post titled “He’s the Kingpin of the Barbecuemen,” Jetton introduced the reporter to an African-American pitmaster named Ethan Boyer, “a dignified, sixty-year-old Negro” who supervised cooking in the brick pits at the restaurant. Jetton called Boyer, who had been with him for thirty years, his “barbecue expert.”")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg37lev1"
    }
  }), _c('span', {
    staticClass: "brown"
  }, [_vm._v("Mechanization")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("In 1946, a machinist named Leonard McNeill won a tiny restaurant near Lenox Street in Houston in a game of craps. He renamed it the Lenox Bar-B-Q. By the 1960s, the restaurant was catering for thousands of guests at a time, and McNeill found himself competing head to head with the legendary Walter Jetton. In 1967, Ann Valentine, food editor of the "), _c('em', [_vm._v("Houston Post")]), _vm._v(", wrote an article about the two mega-caterers titled “The Barbecue Barons.”")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("McNeill prepared food at a restaurant, where he had to abide by the sanitary codes. But ordinary brick barbecue smokers couldn’t accommodate jobs the size of those that the Lenox Bar-B-Q was being asked to do. So the machinist-turned–barbecue baron introduced barbecue to the age of mechanization.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("McNeill bought an enormous bread-rising oven from the Rainbow Bread bakery. The oven had a rotating mechanism inside that moved the dough through a timed cycle. McNeill converted this machinery into a mechanized wood-smoke rotisserie that could cook three thousand pounds of meat at one time.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Today, what’s left of McNeill’s barbecue joint on Harrisburg Boulevard in Houston is run by Erik Mrok, whose father was a friend of McNeill’s. Construction of Houston’s light rail line forced Lenox Barbecue & Catering, as it is now known, to move out of its dining room, which was bulldozed. The restaurant kitchen still uses rotisserie ovens to produce barbecue for take-out and catering.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebar1_hd"
  }, [_vm._v("Linguistic Lore"), _c('br'), _c('strong', [_c('span', {
    staticClass: "font1"
  }, [_c('span', {
    staticClass: "display_type"
  }, [_vm._v("BABRACOT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_vm._v("According to the "), _c('em', [_vm._v("Oxford English Dictionary")]), _vm._v(" entry, the English word "), _c('em', [_vm._v("barbecue")]), _vm._v(" derives from the Spanish word "), _c('em', [_vm._v("barbacoa")]), _vm._v(", which is in turn a variation of "), _c('em', [_vm._v("babracot")]), _vm._v(", a word that comes to us from the Taíno language, part of the Arawakan language family of the Caribbean. In Taíno, however, the term "), _c('em', [_vm._v("babracot")]), _vm._v(" was used for the framework of green sticks that formed the grill, rather than for the cooking itself.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("The Caribbean style of slow smoking on a grate over coals was brought to the Carolinas by African slaves in the 1600s and became the basis for Southern-style barbecue. Advocates of open-pit barbecue once argued that this was the only true barbecue. But nowadays, German-style meat smoked in an enclosed pit, Mexican "), _c('em', [_vm._v("cabrito al pastor")]), _vm._v(" roasted by an open fire, and ribs grilled over direct heat all fall within somebody’s definition of Texas barbecue.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_hdnote"
  }, [_vm._v("All Texans agree, however, that hamburgers and hot dogs are not barbecue.")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "f0038-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0038-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Mr. White. A roadside barbecue stand operator in Palestine, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_c('em', [_vm._v("Photo by Scott Van Osdol")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("The barbecue rotisseries are of a type patented by Herbert Oyler in 1968. Oyler, who owned a barbecue restaurant in Mesquite, also started by tinkering with a barbecue rotisserie made from a bread-rising oven. Whether he was working independently, in competition, or in cooperation with McNeill is not known.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Oyler’s invention is a steel barbecue pit with a rotisserie inside. It has an electric carousel, though no heating elements. It is fueled exclusively with wood burned in a remote firebox. The advantage of the rotisserie is that the meat gets basted with dripping fat, but it is cooked with wood smoke. Although it isn’t exactly an old-fashioned barbecue pit, the results still depend on time, temperature, and the talent of the pitmaster. Oyler pits, made today by J&R Manufacturing, are used by well-known barbecue establishments throughout the state. Bewley pits, made by A. N. Bewley in Dallas, are similar in design.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg40lev1"
    }
  }), _c('span', {
    staticClass: "brown"
  }, [_vm._v("The Portable Pit")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The oil business, which took off in the 1950s, had a big impact on Texas barbecue. Oilmen were not only notoriously fond of smoked meat but also fascinated by barbecue technology.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The backyard charcoal grill of the 1960s was fine for grilling steaks, hamburgers, and hot dogs, but it wasn’t suited to Texas barbecue. In the 1970s and 1980s, a larger, enclosed style of barbecue smoker began to proliferate. It’s not hard to figure out where these Texas-style portable pits came from. Some of them were just oil drums cut in half, with legs and handles welded on. Others were elaborate affairs with multiple smoke chambers, separate fireboxes, chimneys, flues, and grease drains. But all of them were made from oil-field parts.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("“We made the chambers out of used oil pipe. You didn’t want to know what used to be in your barbecue pit in those days,” laughs Wayne Whitworth, founder of Houston’s Pitt’s & Spitt’s, one of the most famous makers of barbecue equipment in Texas.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("“We were metal fabricators; we did big oil-field contracts. We just built barbecue pits for fun,” Whitworth says. There were a lot of barbecue enthusiasts working in the East Texas oil fields. And with all that welding equipment and those parts just lying around, temptation was hard to resist. “If you had all the money it has cost Brown & Root [an oil-field engineering firm] to build barbecue pits, you could feed the world,” Whitworth chuckles.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Although making barbecue pits was once a hobby for the oilman, it became a successful new career. In the early 1980s, when the price of oil fell from thirty dollars a barrel to under ten dollars, the Texas economy went into a tailspin. “In 1983, when oil went to hell, I had my workers making barbecue pits just to keep them busy,” Whitworth remembers.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("“Nowadays, we can’t keep up with the demand,” Whitworth says. “We "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("don’t use old pipe anymore; we use new steel these days. And we can build them as big or as small as you want them.” Pitt’s & Spitt’s is now run by Robert Smith and Ryan Zboril, and the company shows off its new designs at barbecue cook-offs all over the country.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg41lev1"
    }
  }), _c('span', {
    staticClass: "brown"
  }, [_vm._v("Stainless Steel and Gas")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The invention of the high-tech stainless-steel barbecue oven heated by gas or electricity made opening a barbecue joint easy. A few logs are added for smoke, and the cooking process is electronically controlled. The ovens are convenient, they require no expertise to operate, and they avoid problems with air-pollution regulations.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The easy-bake oven of the barbecue world turned barbecue into fast food and gave rise to chains, franchise operations, and a host of mediocre barbecue joints located in shopping centers, in strip malls, and at highway exits across Texas and the rest of the South.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("In order to compete with other strip-mall restaurants, modern barbecue joints offered barbecue at any time of the day, which meant the cooked meats were held in steam tables or ovens for hours. When the meat ran out, refrigerated barbecue cooked the day before was reheated and sliced. The result was a general decline in the quality of Texas barbecue.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg41lev2"
    }
  }), _c('span', {
    staticClass: "brown"
  }, [_vm._v("Back to the Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Recently, a back-to-the-roots movement in Texas barbecue has captured the attention of barbecue lovers across the country. A handful of young pitmasters is going back to the basics in hip, new barbecue joints in major cities across the state. They are the darlings of the national press, and the luscious new style of meats they’re serving is reviving the reputation of Texas barbecue.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Austin’s Aaron Franklin is the best-known of the bunch. In 2015, he became the first barbecue pitmaster to win a James Beard Award, an honor given to the nation’s top chefs. Franklin Barbecue in Austin was named the best barbecue joint in the country by "), _c('em', [_vm._v("Bon App")]), _vm._v("é"), _c('em', [_vm._v("tit")]), _vm._v(" in 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("A second-generation barbecue man (his parents once owned a barbecue joint in Bryan), Franklin pioneered the trend of buying premium meat, charging higher prices, and serving a new style of barbecue. This brisket is fattier, has a crispy bark, is cooked to over 200°F, and is sliced as it’s served. Franklin is also expanding the genre. He not only serves a Southern-style pulled pork sandwich but also tops his pork and chopped brisket sandwiches with Carolina-style coleslaw.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Justin Fourton at Pecan Lodge in the Deep Ellum area of Dallas is famous for his Fred Flintstone–size beef ribs: a single rib weighs 1"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" pounds or more and sells for as much as thirty dollars "), _c('span', {
    attrs: {
      "href": "#/xhtml/106chapter97#page_245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(see page 245)")]), _vm._v(". His wife, Diane, makes Southern sides like collard greens and a banana pudding inspired by her aunt’s recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Ronnie Killen at Killen’s Barbecue in Pearland, a southern suburb of Houston, is also known for USDA Prime brisket, "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("giant beef ribs, pulled pork, pork belly, and home-style side dishes like creamed corn made from fresh corn off the cob.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The CorkScrew BBQ trailer in north Houston is run by the husband-and-wife team of Will and Nichole Buckman, who, not too long after opening, found themselves installing a new J&R Oyler smoker with an eighteen-hundred-pound capacity to keep up with the demand.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("What all of these places have in common are expensive grades of meat, wood-burning pits, fattier brisket with crunchy bark—and long lines of ’cue hounds waiting for the kitchen to open. The line isn’t just a sign of popularity, however. Aaron Franklin suggests that having people waiting in line is critical to the quality of the barbecue.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("When every bit of meat is carved as it is ordered, fresh off the smoker, every customer gets a juicy slice. That’s the way it was done years ago, before high-tech barbecue existed. Just ask Vencil Mares at Taylor Cafe. The dean of Texas pitmasters slices his brisket just like he did when the place first opened in 1948—with a layer of fat on top. “You cut that fat off and you’re cutting all the seasonings off,” he told barbecue writer Daniel Vaughn.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("The move away from fatty barbecue was part of the same national trend that replaced butter with margarine in the middle of the last century. In 1952, in Fort Worth’s "), _c('em', [_vm._v("Star-Telegram")]), _vm._v(", Texas writer J. Frank Dobie observed that “the barbecuers of restaurants . . . all agree that in recent years demand for lean meat is making men and women alike into Jack Sprats. Fat meat is much more easily barbecued than lean meat, and the old-timers all wanted fat meat. Young people nowadays don’t want fat, and lots not young don’t either.”")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("While the new breed of pitmasters is getting a lot of press, they prepare only a tiny percentage of the barbecue consumed in Texas. But lots of traditional barbecue joints have taken notice, so that more and more pitmasters are offering a choice of lean meat or brisket with the fat attached. And you don’t even have to queue up to get it.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("Who is willing to wait in line for a plate of fatty barbecue? You probably won’t be surprised to hear that it’s the same gang of hipster food lovers who made "), _c('em', [_vm._v("chashu")]), _vm._v(" ramen, Wagyu hamburgers, and all kinds of pork belly dishes popular.")]), _vm._v(" "), _c('p', {
    staticClass: "text_indent"
  }, [_vm._v("According to the new “fat means flavor” thinking, fatty barbecue tastes better, too. Fatty end brisket, incredibly marbled beef ribs, and the new Southern-style pulled pork are what hip young barbecue customers are after. We have come full circle. In the 1950s, it was the young customers who demanded leaner barbecue; in the early twenty-first century, it is the young customers who think “fat is where it’s at.”")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "f0043-01"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0043-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Austin pitmaster Aaron Franklin.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b1cf34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09chapter01.vue
// module id = 81
// module chunks = 0